import { RecipientInfoDto } from 'app/models/api-dto.model';
import { AccessControlUserItem } from 'app/shared/access-control/accesscontrol-user-item';

export const adaptToRecipientInfoDto = (items: AccessControlUserItem[]): RecipientInfoDto[] =>
    items.map((item: AccessControlUserItem) => ({
        userId: item.id,
        emailAddress: item.email ? item.email : null,
        // Internal users always get mailed a link.
        receiveLink: true,
        receiveCsv: false,
    }));

export const adaptFromRecipientInfoDto = (items: RecipientInfoDto[]): AccessControlUserItem[] =>
    items.map((item: RecipientInfoDto) => ({
        id: item.userId,
        email: item.emailAddress,
    }));
